/**
 * JsonLd — renders a <script type="application/ld+json"> block into the DOM so
 * search engines and AI crawlers can parse structured data (schema.org).
 *
 * Rendered inline in the page body (Google reads JSON-LD anywhere in the
 * document). Because it's real DOM, a puppeteer-style prerender (react-snap)
 * serializes it into the static HTML too — so non-JS crawlers get it as well.
 *
 * `<` is escaped to < to prevent any chance of the JSON string breaking
 * out of the <script> element.
 */
export function JsonLd({ data }: { data: Record<string, unknown> | Record<string, unknown>[] }) {
  const json = JSON.stringify(data).replace(/</g, "\\u003c");
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />;
}

/** Build a schema.org FAQPage object from plain-text Q&A pairs. */
export function faqPageSchema(faqs: { question: string; answer: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };
}

/** Build accurate breadcrumb markup for a public page. */
export function breadcrumbSchema(items: { name: string; path: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `https://playceacademy.com${item.path}`,
    })),
  };
}
